import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FaSnowflake, FaPhone, FaBars, FaTimes } from "react-icons/fa";
import HeadlineTicker from "./HeadlineTicker";

const NavigationBar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  const handleNavClick = () => {
    setIsExpanded(false);
  };

  return (
    <>
      {/* Top Headline Ticker (not sticky) */}
      <HeadlineTicker />

      {/* Main Navbar (sticky/fixed) */}
      <Navbar
        expand="lg"
        className="main-navbar bg-white shadow-sm"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1020,
          width: "100%",
        }}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <img
              src="/logo.png"
              alt="Moiz AC Repair Logo"
              style={{ height: "50px", marginRight: "10px" }}
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setIsExpanded(!isExpanded)}
            className="border-0"
          >
            {isExpanded ? <FaTimes /> : <FaBars />}
          </Navbar.Toggle>

          <Navbar.Collapse
            id="basic-navbar-nav"
            className={isExpanded ? "show" : ""}
          >
            <Nav className="ms-auto align-items-center">
              <Nav.Link
                as={Link}
                to="/"
                className={`fw-medium ${
                  location.pathname === "/" ? "text-primary" : "text-dark"
                }`}
                onClick={handleNavClick}
              >
                Home
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/commercial"
                className={`fw-medium ${
                  location.pathname === "/commercial"
                    ? "text-primary"
                    : "text-dark"
                }`}
                onClick={handleNavClick}
              >
                Commercial
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/residential"
                className={`fw-medium ${
                  location.pathname === "/residential"
                    ? "text-primary"
                    : "text-dark"
                }`}
                onClick={handleNavClick}
              >
                Residential
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/booking"
                className={`fw-medium ${
                  location.pathname === "/booking"
                    ? "text-primary"
                    : "text-dark"
                }`}
                onClick={handleNavClick}
              >
                Book Appointment
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/contact"
                className={`fw-medium ${
                  location.pathname === "/contact"
                    ? "text-primary"
                    : "text-dark"
                }`}
                onClick={handleNavClick}
              >
                Contact
              </Nav.Link>
              <Button
                as="a"
                href="tel:+923054743725"
                variant="primary"
                className="ms-3 rounded-pill d-flex align-items-center"
              >
                <FaPhone className="me-2" />
                <span>Call Now</span>
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default NavigationBar;
